<template>
<div>
	<div class="d-flex mt-2 justify-content-between align-items-center">

		<div>
			<field v-if="hasAssemblies"
				class="mt-2 mb-2"
				:params="{type:'btn-group',buttons:[
					{text:'Assemblies',value:true},{text:'Raw Materials',value:false}
				],tabStyling:true}" 
				v-model="assemblyView">
			</field>
		</div>

		<div>

			<button v-if="!isFinalized" class="btn btn-primary" type="button" v-on:click="selectorModal.visible = true">
				<i class="fa fa-plus"></i>
				Add
			</button>
		</div>
	</div>

	<div>
		<button v-if="selectedRecords.length > 0 && !isFinalized" type="button" class="btn btn-light btn-sm" v-on:click="editBulkSelection">
			<i class="fa fa-pencil-alt"></i>
			Bulk Edit
		</button>
	</div>

	<table-list v-if="hasAssemblies && assemblyView"
		:records="mutatedAssemblies"
		:fields="assemblyFields"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:simple-delete="true"
		:sortable="true"
		:hide-record-count="true"
		:collapse-buttons="true"
		record-name="Assembly Item"
		v-on:delete="deleteAssembly"
		v-on:edit="editAssembly">

	</table-list>

	<table-list v-else
		:records="mutatedAndCondensedMaterials"
		:fields="materialsFields(hasAssemblies)"
		:has-delete="!isFinalized"
		:simple-delete="true"
		:has-edit="!isFinalized"
		:sortable="true"
		:hide-record-count="true"
		record-name="Material"
		:records-selectable="!isFinalized"
		record-locked-property="belongsToAssembly"
		id-field="objectRecordId"
		:other-buttons="!isFinalized ? [
			{
				text: 'Edit',
				click: 'lockedEdit',
				condition: ['belongsToAssembly',true],
				class: 'btn-light',
				icon: 'fa-pencil-alt'
			}
		] : false"
		v-on:lockedEdit="lockedEditModalVisible = true"
		v-on:selectedRecordsChange="setSelectedRecords"
		v-on:edit="editMaterial"
		v-on:delete="removeMaterial">

	</table-list>

	<info-box class="float-right mb-2" 
		label="Total" 
		:value="totalRecordsValue(mutatedAndCondensedMaterials).toCurrency()">
	</info-box>
	<div style="clear: both;"></div>

	<material-selector-modal 
		:visible="selectorModal.visible"
		:working="selectorModal.working"
		v-on:closeModal="selectorModal.visible = false"
		v-on:addMaterials="addMaterials">
	</material-selector-modal>

	<billing-document-material-edit-modal :visible="materialEditModal.visible"
		title="Edit Material"
		price-adjustment-label="Price Adjustment"
		:price-adjustment-step="0.0001"
		:client-invoice-settings="{}"
		:record="materialEditModal.record"
		v-on:save="materialEditSave"
		v-on:closeModal="materialEditModal.visible = false">
	</billing-document-material-edit-modal>

	<bid-element-bulk-edit-modal :visible="bulkEditModal.visible"
		title="Bulk Edit"
		:records="selectedRecords"
		type="Material"
		:bid-id="component ? component.bid_id : false"
		:component="component"
		v-on:saved="bulkEditSaved"
		v-on:closeModal="bulkEditModal.visible = false">
	</bid-element-bulk-edit-modal>

	<billing-document-assembly-edit-modal
		:record="assemblyEditModal.payload"
		:visible="assemblyEditModal.visible"
		v-on:viewAssemblyDetails="viewAssemblyDetails"
		v-on:disconnectChildMaterials="disconnectChildMaterials"
		v-on:confirm="confirmAssemblyEdit"
		v-on:closeModal="assemblyEditModal.visible = false">
	</billing-document-assembly-edit-modal>

	<assembly-details-modal :readonly="true"
		:visible="assemblyDetailsModal.visible"
		:record="assemblyDetailsModal.record ? {
			id: assemblyDetailsModal.record.assembly_id,
			description: assemblyDetailsModal.record.description,
			unit_type: assemblyDetailsModal.record.unit_type,
			AssemblyTag: []
		} : false"
		:title="assemblyDetailsModal.title"
		v-on:assemblyItemsFetched="assemblyItemsFetched"
		v-on:closeModal="closeDetailsModal">

		<alert v-if="assemblyUpdatedSinceAdded" 
			visible="true" 
			unclosable="true" 
			icon="fa-exclamation-circle"
			class="alert-warning">

			This assembly changed since being added to the bid component on {{ formatDateTimeToLocal(assemblyDetailsModal.record.addedAt,'full-date-time') }}. In order to apply the changes to the bid, you must remove and re-add the assembly
		</alert>

	</assembly-details-modal>

	<modal-dialog :modal-visible="lockedEditModalVisible"
		title="Assembly Material"
		v-on:closeModal="lockedEditModalVisible = false"
		:submit-visible="false"
		cancel-button-text="Done">

		<p>This material belongs to an assembly and therefore it can't be edited individually. You have two options here.</p>

		<ol>
			<li>You edit all material together through the Bulk Edit feature found on the raw materials tab.</li>

			<li>If you want to control this material independently, you can disconnect the assembly's materials by going to the Assemblies tab, edit the assembly, and click the "Disconnect Materials..." button.</li>
		</ol>

	</modal-dialog>

</div>
</template>
<script type="text/javascript">

import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import BillingDocumentMaterialEditModal from "@/components/BillingDocumentMaterialEditModal"
import BidElementBulkEditModal from "@/pages/project/project_tabs/bidding/components/BidElementBulkEditModal"
import BillingDocumentAssemblyEditModal from "@/components/BillingDocumentAssemblyEditModal"
import AssemblyDetailsModal from "@/components/super_components/AssemblyDetailsModal"
import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import Alert from "@/components/Alert"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"
import InvoiceMaterialMixins from "@/mixins/InvoiceMaterialMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "MaterialSection",
	components: {
		TableList,
		InfoBox,
		MaterialSelectorModal,
		BillingDocumentMaterialEditModal,
		BillingDocumentAssemblyEditModal,
		BidElementBulkEditModal,
		Field,
		AssemblyDetailsModal,
		ModalDialog,
		Alert
	},
	mixins: [ProjectBidMixins,InvoiceMaterialMixins,InvoiceMixins],
	props: [
		"materials",
		"component",
		"billingDocumentObjectResource",
		"billingDocumentAssemblies",
		"isFinalized"
	],
	data() {
		return {
			materialEditModal: {
				visible: false,
				record: null
			},
			bulkEditModal: {
				visible: false
			},
			selectedRecords: [],
			selectorModal: {
				visible: false
			},
			assemblyView: false,
			lockedEditModalVisible: false
		}
	},
	watch: {
		component() {

		}
	},
	computed: {
		billingDocumentId() {
			if (this.component)
				return this.component.id

			return false
		},
		billingDocumentMaterials() {
			return this.materials
		},
		assemblyUpdatedSinceAdded() {
			if (!this.assemblyDetailsModal.record || !("addedAt" in this.assemblyDetailsModal.record))
				return false

			let assemblyAddedAt = this.moment.utc(this.assemblyDetailsModal.record.addedAt)

			let updatedItem = this.assemblyDetailsModal.assemblyItems.find(item => {
				let itemUpdatedAt = this.moment.utc(item.updated_at)

				if (!assemblyAddedAt.isBefore(itemUpdatedAt))
					return true
			})

			if (updatedItem)
				return true
			

			return false
		}
	},
	methods: {
		/*
		addMaterialsToComponent(materials) {
			let vm = this

			this.materialModalVisible = false

			this.materialsLocal = [
				...this.materialsLocal,
				...materials
			]

			let payload = {
				records: JSON.stringify(materials.map(mat => {

					let rate = 0
					if ("per" in mat && mat.per && mat.per != 1)
						rate = +mat.price / +mat.per
					else
						rate = +mat.price

					let obj = {
						bid_component_id: vm.component.id,
						type: "Material",
						qty: mat.qty,
						object_id: mat.id,
						markup: 1,
						price_adjustment: 1,
						rate
					}

					obj.field_values_json = JSON.stringify(mat)

					return obj
				}))
			}

			this.postData("JobBidComponentObject/save-batch",payload,true).then(response => {
				if (response.success)
					vm.$emit("modelChanged")
			})
		},
		*/
		removeMaterial(mat,index) {
			let vm = this
			let matsToDelete = this.materials.filter(matFromList => matFromList.material_id == mat.material_id)

			let promises = []

			matsToDelete.forEach(matToDelete => {
				promises.push(vm.postData("JobBidComponentObject/delete",{id: matToDelete.objectRecordId},true))
			})

			Promise.all(promises).then(responses => {
				vm.$emit("modelChanged")
			})
			
		},
		editMaterial(mat,index) {
			this.materialEditModal.visible = true
			this.materialEditModal.record = mat
		},
		setSelectedRecords(records) {
			this.selectedRecords = records
		},
		editBulkSelection() {
			this.bulkEditModal.visible = true
		},
		/*
		materialEditSave(data) {
			let vm = this
			let mat = data.payload

			//updated fields
			let payload = {
				id: mat.objectRecordId,
				qty: mat.qty,
				rate: +mat.price / +mat.per,
				price: +mat.price,
				markup: +mat.markup,
				price_adjustment: +mat.priceAdjustment
			}

			mat.price_adjustment = mat.priceAdjustment

			let fieldsToDelete = ["total","totalFormatted","totalRaw","unitTotalRaw","totalUnitPrice","priceAdjustment","priceAdjustmentFormatted","selected","itemType","sourceAssemblyDescription","unit_total","rowClasses"]
			fieldsToDelete.forEach(key => {
				delete mat[key]
			})

			delete mat.priceAdjustment

			payload.field_values_json = JSON.stringify(mat)

			this.postData("JobBidComponentObject/save",payload,true).then(response => {
				if (response.success) {
					vm.$emit("modelChanged")
					vm.materialEditModal.visible = false
				}
			})
		},
		*/
		materialEditSave(data) {
		  const vm = this
		  const mat = data.payload

		  // 1) Find all DB rows that would have been condensed with this one
		  const siblings = (this.billingDocumentMaterials || []).filter(row => {
			if (!("objectRecordId" in row)) return false
			return vm.materialsMatchForCondensing(row, mat)
		  })

		  const priceAdjustment = +(
			("priceAdjustment" in mat && mat.priceAdjustment != null)
				? mat.priceAdjustment
				: mat.price_adjustment
		  )

		  // Pick a survivor: prefer the currently edited row; if not found fall back to first sibling
		  const survivorId = mat.objectRecordId || (siblings[0] && siblings[0].objectRecordId)
		  const deleteIds = siblings
			.map(r => r.objectRecordId)
			.filter(id => id && id !== survivorId)

		  // 2) Build update payload for survivor
		  const rate = +mat.price / +mat.per
		  // Keep UI & server in sync on naming
		  mat.price_adjustment = priceAdjustment

		  // Strip UI-only/computed fields from field_values_json
		  const fieldsToDelete = [
			"total","totalFormatted","totalRaw","unitTotalRaw","totalUnitPrice",
			"priceAdjustment","priceAdjustmentFormatted","selected","itemType",
			"sourceAssemblyDescription","unit_total","rowClasses","merged","sourceObjects"
		  ]
		  fieldsToDelete.forEach(k => { delete mat[k] })

		  const updatePayload = {
			id: survivorId,
			qty: +mat.qty,            // <- new total you want after consolidation
			rate,
			price: +mat.price,
			markup: +mat.markup,
			price_adjustment: priceAdjustment,
			field_values_json: JSON.stringify(mat)
		  }

		  // Some documents need an explicit document id on save; mirror your existing code:
		  if (vm.billingDocumentObjectResource === 'ServiceInvoiceObject')
			updatePayload.invoice_id = vm.billingDocumentId
		  else if (vm.billingDocumentObjectResource === 'JobChangeOrderObject')
			updatePayload.quote_id = vm.billingDocumentId
		  else if (vm.billingDocumentObjectResource === 'JobBidComponentObject')
			updatePayload.bid_component_id = vm.billingDocumentId

		  // 3) Run deletions (if any), then save the survivor
		  const delCalls = deleteIds.map(id =>
			vm.postData(vm.billingDocumentObjectResource + "/delete", { id }, true)
		  )

		  Promise.all(delCalls).then(() => {
			return vm.postData(vm.billingDocumentObjectResource + "/save", updatePayload, true)
		  }).then(resp => {
			if (resp && resp.success) {
			  vm.$emit("modelChanged")
			  vm.materialEditModal.visible = false
			}
		  })
		},
		bulkEditSaved() {
			this.$emit('modelChanged')
		},
		confirmAssemblyEdit(payload) {
			this.assemblyEditModal.payload = payload
			this.saveAssemblyEdit()
		},
		disconnectChildMaterials() {
			let vm = this
			let records = []

			//remove link in all materials that belong to this assembly
			this.materials.forEach(mat => {

				if ("belongsToAssembly" in mat && mat.belongsToAssembly && "parentAssemblies" in mat && mat.parentAssemblies) {
					let parentAsseblyRefIndex = mat.parentAssemblies.findIndex(ref => ref.assembly_id == vm.assemblyEditModal.payload.assembly_id)

					if (parentAsseblyRefIndex >= 0) {
						//remove it from the refs list
						mat.parentAssemblies.splice(parentAsseblyRefIndex,1)

						if (mat.parentAssemblies.length == 0)
							delete mat.parentAssemblies

						mat.type = "Material"
						mat.belongsToAssembly = false
						mat.id = mat.objectRecordId
						mat.bid_component_id = mat.bid_component_id

						records.push(vm.renderDocumentObjectPayload(mat, "JobBidComponentObject"))
					}
				}
			})

			//now we need to flag this assembly as disconnected

			let assemblyPayload = vm.cloneObj(vm.assemblyEditModal.payload)
			
			assemblyPayload.id = vm.assemblyEditModal.payload.objectRecordId
			assemblyPayload.type = "Assembly"
			assemblyPayload.bid_component_id = vm.component.id
			assemblyPayload.isDisconnected = true

			records.push(vm.renderDocumentObjectPayload(assemblyPayload, "JobBidComponentObject"))

			vm.postData("JobBidComponentObject/save-batch", {records: JSON.stringify(records)}, true).then(response => {
				vm.$emit("modelChanged")
			})

			vm.assemblyEditModal.visible = false
		}
	},
	created() {
		
	}
}

</script>